import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const partnersCarousels = document.querySelectorAll(
    '.partners-carousel-block .partners-carousel__carousel'
  );

  if (0 < partnersCarousels.length) {
    partnersCarousels.forEach((carousel) => {
      const swiper = new Swiper(carousel, {
        slidesPerView: 3,
        spaceBetween: 40,
        loop: true,
        autoplay: {
          delay: 2000,
        },
        breakpoints: {
          768: {
            slidesPerView: 6,
            spaceBetween: 40,
          },
          1080: {
            slidesPerView: 12,
            spaceBetween: 40,
          },
        },
      });

      // Fonction pour activer/désactiver les animations
      function toggleSwiperAnimation() {
        if (document.documentElement.classList.contains('no-animation')) {
          swiper.autoplay.stop(); // Stopper l'autoplay
          swiper.params.speed = 0; // Désactiver les animations
        } else {
          swiper.autoplay.start(); // Démarrer l'autoplay
          swiper.params.speed = 300; // Activer les animations
        }
        swiper.update(); // Mettre à jour Swiper avec les nouveaux paramètres
      }

      // Vérifier initialement si la classe 'no-animation' est présente
      toggleSwiperAnimation();

      // Observer les changements de classes sur la balise html
      const observer = new MutationObserver(() => {
        toggleSwiperAnimation();
      });

      // Configurer l'observateur pour surveiller les attributs
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    });
  }
});
